"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-spring-manufacturing";
const IMAGE_BASE = "/image/new-version/more/SpringManufacturing/Services";

const SERVICES = [
	{ keyPrefix: "servicesCard1", image: "compression-springs.webp" },
	{ keyPrefix: "servicesCard2", image: "extension-springs.webp" },
	{ keyPrefix: "servicesCard3", image: "torsion-springs.webp" },
	{ keyPrefix: "servicesCard4", image: "custom-spring-fabrication.webp" },
] as const;

export default function SpringManufacturingServices() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("servicesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("servicesDesc")}</p>
				</header>

				<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
					{SERVICES.map((service) => (
						<article
							key={service.keyPrefix}
							className="flex h-full flex-col overflow-hidden rounded-lg border border-gray-300 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
						>
							<div className="relative aspect-[4/2.45] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={`${IMAGE_BASE}/${service.image}`}
									alt={t(`${service.keyPrefix}ImageAlt`)}
									fill
									className="object-cover transition-transform duration-500 hover:scale-105"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
								/>
							</div>
							<div className="flex flex-1 flex-col p-4 sm:p-5">
								<h3 className="mb-2 text-lg font-bold text-black sm:text-xl">
									{t(`${service.keyPrefix}Title`)}
								</h3>
								<p className="mb-5 text-sm leading-relaxed text-black">{t(`${service.keyPrefix}Desc`)}</p>
								<Link
									href="/upload"
									className="mt-auto inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-[#83b751] sm:text-sm"
								>
									{t("servicesGetQuote")}
								</Link>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
